import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./services/auth-context";
import { CoMemberLayout } from "./layouts/CoMemberLayout";
import { CompanyLayout } from "./layouts/CompanyLayout";
import { CoMemberLoginPage } from "./pages/co-member/Login";
import { EmployeeSignInPage } from "./pages/employee/SignIn";
import { ComingSoon } from "./components/ComingSoon";
import { QuestionBankPage } from "./pages/co-member/QuestionBank";
import { CompanyListPage } from "./pages/co-member/CompanyList";
import { CompanyDetailPage } from "./pages/co-member/CompanyDetail";
import { AssignmentBuilderPage } from "./pages/co-member/AssignmentBuilder";
import { GradingPage } from "./pages/co-member/Grading";
import { CoMemberHomePage } from "./pages/co-member/Home";
import { TakeTestPage } from "./pages/employee/TakeTest";
import { ResultPage } from "./pages/employee/Result";
import { DashboardCompanyPickerPage } from "./pages/co-member/DashboardCompanyPicker";
import { CompanyDashboardPage } from "./pages/co-member/CompanyDashboard";
import { SignInRouter } from "./pages/SignInRouter";
import { DashboardRouter } from "./pages/DashboardRouter";
import { MemberResultPage } from "./pages/manager/MemberResult";
import { CoMemberSettingsPage } from "./pages/co-member/Settings";
import { SubmissionsPage } from "./pages/co-member/Submissions";
import { EmployeeSettingsPage } from "./pages/employee/Settings";

export function AppRouter() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/co-member/login" replace />} />

          {/* CO Member portal (plan.md > Navigation Structure) */}
          <Route path="/co-member/login" element={<CoMemberLoginPage />} />
          <Route path="/co-member" element={<CoMemberLayout />}>
            <Route index element={<CoMemberHomePage />} />
            <Route path="tests" element={<ComingSoon title="Tests" />} />
            <Route path="questions" element={<QuestionBankPage />} />
            <Route path="companies" element={<CompanyListPage />} />
            <Route path="companies/:companyId" element={<CompanyDetailPage />} />
            <Route path="companies/:companyId/assignments/new" element={<AssignmentBuilderPage />} />
            <Route path="companies/:companyId/grading" element={<GradingPage />} />
            <Route path="companies/:companyId/submissions" element={<SubmissionsPage />} />
            <Route path="dashboard" element={<DashboardCompanyPickerPage />} />
            <Route path="dashboard/:companyId" element={<CompanyDashboardPage />} />
            <Route path="settings" element={<CoMemberSettingsPage />} />
          </Route>

          {/* Company member (Employee/Manager) portal — same layout, role-based sidebar */}
          <Route path="/company/:slug/login" element={<EmployeeSignInPage />} />
          <Route path="/company/:slug" element={<CompanyLayout />}>
            <Route index element={<SignInRouter />} />
            <Route path="test" element={<TakeTestPage />} />
            <Route path="result" element={<ResultPage />} />
            <Route path="dashboard" element={<DashboardRouter />} />
            <Route path="dashboard/members/:memberId" element={<MemberResultPage />} />
            <Route path="settings" element={<EmployeeSettingsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
